import { useCallback, useState } from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { Spacing8 } from 'autogen/design-tokens/tokens';
import { AiName, ClearHistory } from 'autogen/translation-keys/trans-website-comai';
import Button from 'components/Button/Button';
import useDrawer, { closeAllDrawers, closeDrawer } from 'components/generic/Drawer/hooks/useDrawer';
import { Typography } from 'components/generic/typography';
import Icon from 'components/Icon/Icon';
import FlexRow from 'components/Layout/components/Flex/components/FlexRow';
import Loader from 'components/Loader';
import { COM_AI_DRAWER_ID, COM_AI_FEEDBACK_DRAWER_ID } from '../shared/consts';
import { useInitializeChat } from '../store/comAIStore';

const TEMP_ICON_AI = 'AI';

const Wrapper = styled.div`
    display: flex;
    border-bottom: 1px solid ${({ theme }) => theme.ColorBorderSecondary};
    justify-content: space-between;
    align-items: center;
    height: ${({ theme }) => theme.Spacing48};
    padding: 0 ${({ theme }) => theme.Spacing8};
    flex-shrink: 0;
    gap: ${({ theme }) => theme.Spacing8};
`;

const Content = styled.div`
        flex: 1 1 auto;
    `;

export default function Header() {
    const [resetLoading, setResetLoading] = useState(false);

    const init = useInitializeChat();
    const comAIFeedbackDrawer = useDrawer(COM_AI_FEEDBACK_DRAWER_ID, { disableOverlay: true });
    const { t } = useTranslation();

    const clearHistory = useCallback(async () => {
        setResetLoading(true);
        await init(true);
        setResetLoading(false);
    }, [init]);

    const closeChat = useCallback(() => {
        comAIFeedbackDrawer.open();
        closeDrawer(COM_AI_DRAWER_ID);
        clearHistory();
    }, [comAIFeedbackDrawer.open, clearHistory]);

    return (
        <Wrapper>
            <Content>
                <FlexRow justifyContent="space-between" alignItems="center">
                    <FlexRow gap="0px" alignItems="center">
                        <Icon type={TEMP_ICON_AI} style={{ marginLeft: Spacing8, marginRight: Spacing8 }} size={16} />
                        <Typography.Headline size="S">{t(AiName)}</Typography.Headline>
                    </FlexRow>
                    <Button.WithIcon
                        variant="ghost"
                        icon={resetLoading ? <Loader size={16} /> : <Icon type="Restart" size={16} />}
                        size="sm"
                        iconProperties={{ position: 'right' }}
                        onClick={clearHistory}
                    >
                        {t(ClearHistory)}
                    </Button.WithIcon>
                </FlexRow>
            </Content>
            <Button.WithIcon
                variant="navigation"
                size="sm"
                icon={<Icon type="Minus" size={16} />}
                onClick={() => closeAllDrawers()}
            />
            <Button.WithIcon
                variant="navigation"
                size="sm"
                icon={<Icon type="Close" size={16} />}
                onClick={closeChat}
            />
        </Wrapper>
    );
}
